export const headerParams = {
	height: 40,
};
